import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * MasPatitas product card.
 *
 * Adding to the cart is handled by Horizon's `product-form-component` inside the card, which
 * updates the cart drawer and cart count. This component only listens for that add and, once
 * the event promise settles without error, marks the card as added so the pill reads "✓ Añadido".
 *
 * @extends {Component}
 */
class MpProductCard extends Component {
  /** @type {AbortController | null} */
  #controller = null;

  connectedCallback() {
    super.connectedCallback();

    this.#controller?.abort();
    this.#controller = new AbortController();
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#handleCartLinesUpdate, {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#controller?.abort();
    this.#controller = null;
  }

  /**
   * @param {import('@shopify/events').CartLinesUpdateEvent} event
   */
  #handleCartLinesUpdate = async (event) => {
    if (event.action !== 'add') return;
    if (!(event.target instanceof Node) || !this.contains(event.target)) return;

    try {
      const result = await event.promise;
      if (!this.isConnected || result?.detail?.didError) return;

      this.dataset.added = 'true';
    } catch (error) {
      // The theme surfaces cart errors; the card simply keeps its default label.
      if (error?.name !== 'AbortError') console.warn('[mp-product-card] Add to cart failed:', error);
    }
  };
}

if (!customElements.get('mp-product-card')) {
  customElements.define('mp-product-card', MpProductCard);
}
